import * as React from 'react';
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={19.656} {...props}>
    <g transform="translate(-5.68 -8.17)">
      <circle
        cx={6.897}
        cy={6.897}
        r={6.897}
        fill="#ff5e2c"
        data-name="Ellipse 320"
        transform="translate(5.68 8.17)"
      />
      <path
        fill="#b7370f"
        d="M12.651 20.959a.345.345 0 0 0 .343.315h.03a.345.345 0 0 0 .314-.373 7.218 7.218 0 0 0-1.85-4.254l1.092-1.092 1.136 1.136a.345.345 0 0 0 .488-.487l-1.136-1.136 1.1-1.1a7.3 7.3 0 0 0 1.353.973.345.345 0 1 0 .335-.6 6.545 6.545 0 0 1-1.2-.859l3.032-3.035a6.893 6.893 0 0 0-.488-.488l-3.038 3.039a6.533 6.533 0 0 1-1.667-3.919l-.062-.865a.317.317 0 0 0-.01-.037c-.227 0-.451.019-.673.046a.384.384 0 0 0 0 .039l.062.865a7.216 7.216 0 0 0 1.865 4.355l-1.099 1.097-4.622-4.621a6.621 6.621 0 0 0-.488.489l4.621 4.62-1.092 1.092a7.216 7.216 0 0 0-4.358-1.862l-.865-.062h-.039q-.039.332-.046.672l.037.01.865.062a6.534 6.534 0 0 1 3.917 1.663l-3.04 3.041q.232.256.488.488l3.041-3.039a6.533 6.533 0 0 1 1.654 3.823Z"
        data-name="Path 12548"
      />
      <path
        fill="#edebeb"
        d="M13.42 20.93a6.207 6.207 0 1 1 7.43 4.673 6.071 6.071 0 0 1-.688.116"
        data-name="Path 12549"
      />
      <path
        fill="#1a1a1a"
        d="M25.637 18.841a6.174 6.174 0 0 0-1-2.74 6.286 6.286 0 0 0-.543-.689h-.48a.345.345 0 0 0-.331.25l-.649 2.269-1.055.538-1.759-1.172v-1.365l1.922-1.345a.346.346 0 0 0 .135-.373l-.119-.435a6.223 6.223 0 0 0-4.535-.011l-.144.428a.345.345 0 0 0 .129.393l1.922 1.345v1.36l-1.764 1.176-1.418-.568-.635-1.586a.35.35 0 0 0-.166-.181l-.627-.313a6.155 6.155 0 0 0-1.233 3.363c-.007.121-.018.241-.018.363s0 .263.013.392l.522.261a.344.344 0 0 0 .4-.065l1.563-1.563 1.356.543.643 2.251a.345.345 0 0 0 .331.249h2.616l.759.759-.924 1.847a.345.345 0 0 0 .04.371l.716.886a6.152 6.152 0 0 0 3.552-2.842l-.241-.484a.344.344 0 0 0-.31-.191h-2.271l-.79-.79.586-2.057 1.071-.547 1.9 1.267a.344.344 0 0 0 .345.021l.534-.267v-.042a6.063 6.063 0 0 0-.042-.709Z"
        data-name="Path 12550"
      />
      <path
        fill="#4f2400"
        d="m7.035 25.22 1.109.832a8.864 8.864 0 0 0 5.319 1.773h.987a8.865 8.865 0 0 0 5.319-1.773l1.109-.832a.689.689 0 0 0 .138-.965.651.651 0 0 0-.086-.094l-.983-.9a8.865 8.865 0 0 0-11.981 0l-.983.9a.69.69 0 0 0-.042.974.739.739 0 0 0 .094.086Z"
        data-name="Path 12551"
      />
      <g fill="#ff5c00" data-name="Group 10483">
        <path
          d="M17.06 24.722h-6.9a.345.345 0 1 1 0-.69h6.9a.345.345 0 0 1 0 .69Z"
          data-name="Path 12552"
        />
        <path
          d="M10.858 25.412a.345.345 0 0 1-.345-.345v-1.38a.345.345 0 0 1 .69 0v1.38a.345.345 0 0 1-.345.345Z"
          data-name="Path 12553"
        />
        <path
          d="M12.237 25.412a.345.345 0 0 1-.345-.345v-1.38a.345.345 0 0 1 .69 0v1.38a.345.345 0 0 1-.345.345Z"
          data-name="Path 12554"
        />
        <path
          d="M13.607 25.412a.345.345 0 0 1-.345-.345v-1.38a.345.345 0 0 1 .69 0v1.38a.345.345 0 0 1-.345.345Z"
          data-name="Path 12555"
        />
        <path
          d="M14.991 25.412a.345.345 0 0 1-.345-.345v-1.38a.345.345 0 0 1 .69 0v1.38a.345.345 0 0 1-.345.345Z"
          data-name="Path 12556"
        />
        <path
          d="M16.37 25.412a.345.345 0 0 1-.345-.345v-1.38a.345.345 0 0 1 .69 0v1.38a.345.345 0 0 1-.345.345Z"
          data-name="Path 12557"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
